module.exports = __webpack_public_path__ + "img/atom_blue.df734d1e.svg";